// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectOutdoorSpaceQueryResult, selectOutdoorSpacesPageLoading, selectOutdoorSpacesShowInitWaitingMessage} from '../_selectors/outdoor-space.selectors';

export class OutdoorSpacesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOutdoorSpacesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOutdoorSpacesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOutdoorSpaceQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
